<template>
  <a-modal
    destroyOnClose
    :maskClosable="false"
    :visible="visible"
    width="576px"
    :footer="null"
    centered
    @cancel="handleCloseModal"
>
    <div class="container__info">
      <img class="image__whatsapp" :src="record.channel_icon" alt="whatsApp">
      <h1 class="title">Empieza a recibir llamadas de tus contactos desde WhatsApp.</h1>
      <p class="subtitle">Con WhatsApp Voice podrás realizar todo lo siguiente:</p>
    </div>

    <div class="content">
      <p class="benefits">Beneficios:</p>
      <ul class="benefits__list">
        <li>
          <img class="bullet" :src="send" alt="send">
          Conéctate con tus contactos mediante plantillas de llamada cuando lo necesites.
        </li>
        <li>
          <img class="bullet" :src="callIncoming" alt="callIncoming">
          Habilita un botón de llamada en tu cuenta de WhatsApp Business API Oficial para que tus contactos te llamen.
        </li>
        <li>
          <img class="bullet" :src="comment" alt="comment">
          Vincula el identificador de WhatsApp Voice a colas o IVRs como lo necesites.
        </li>
      </ul>
  
      <div class="button__activate">
        <a-button 
          style="width: 420px" 
          type="primary" 
          class="footer__activate"
          @click="handleActivateVoice" 
          :loading="loading"
        >
          {{ loading ? 'Activando…' : 'Activar WhatsApp Voice' }}
        </a-button>
      </div>
  
      <span class="footer">
        Para mayor información: 
        <a type="link" :href="linkWhatsappVoice" target="_blank" class="external-link">
          Leer más sobre WhatsApp Voice
          <IconExternalLink active />
        </a>
      </span>
    </div>
  </a-modal>
</template>

<script>
import { defineComponent } from 'vue';
import { message } from 'ant-design-vue';
import { createEnableVoice } from '@/app/channels/services';
import send from "@/app/channels/assets/send.svg?url";
import comment from "@/app/channels/assets/comment.svg?url";
import callIncoming from "@/app/channels/assets/call-incoming.svg?url";
import IconExternalLink from "@/app/common/components/atoms/IconExternalLink.vue";

const linkWhatsappVoice = `${import.meta.env.VITE_CONTACT_CENTER_BEEX}precios/`;

export default defineComponent({
  name: "ActivateVoiceModal",
  components: {
    IconExternalLink,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    record: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      loading: false,
      send,
      comment,
      callIncoming,
      linkWhatsappVoice,
    };
  },
  methods: {
    handleCloseModal() {
      this.$emit("reloadTable");
      this.$emit("onClose");
    },
    
    async handleActivateVoice(){
      this.loading = true
      try {
        const response = await createEnableVoice(this.record.id);
        message.success(response.message);
        this.handleCloseModal();    
      } catch (error) {
        const errorMessage = error?.getCleanErrorMessage() || "Ha ocurrido un error al activar Voice";
        message.warning(errorMessage);
      } finally {
        this.loading = false;
      }
    },
  },
});
</script>

<style lang="sass" scoped>
.container__info
  text-align: center
  margin-top: 28px

.image__whatsapp
  width: 40px
  height: 40px
  margin-bottom: 10px

.title
  width: 420px 
  margin: 0 auto 
  font-size: 24px
  font-weight: 600

.subtitle
  color: #000000A6
  margin-top: 14px

.content
  width: 420px       
  margin: 0 auto       

.benefits
  margin-bottom: 20px
  font-weight: 600

.benefits__list
  padding: 0
  margin: 0 0 20px
  list-style: none
  color: #000000A6
  display: flex
  flex-direction: column
  row-gap: 12px          

li
  display: flex
  column-gap: 8px        
  align-items: flex-start

.button__activate
  margin-top: 10px
  display: flex
  justify-content: center

.footer__activate
  margin-bottom: 20px

.footer
  display: block
  text-align: center
  color: #000000A6
  margin-bottom: 28px

.external-link
  display: inline-flex
  align-items: center       
  gap: 6px                   
</style>
